"use client";

import React from "react";
import { Hospital, Activity } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const SurgicalMask = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M21 10c0-3-2-5-5-5H8C5 5 3 7 3 10v4c0 3 2 5 5 5h8c3 0 5-2 5-5v-4Z" />
    <path d="M3 8.5c-1.5-1-2-2.5-2-4" />
    <path d="M3 15.5c-1.5 1-2 2.5-2 4" />
    <path d="M21 8.5c1.5-1 2-2.5 2-4" />
    <path d="M21 15.5c1.5 1-2 2.5-2 4" />
    <line x1="7" y1="10" x2="17" y2="10" />
    <line x1="7" y1="12" x2="17" y2="12" />
    <line x1="7" y1="14" x2="17" y2="14" />
  </svg>;
const PatientIcon = ({
  className
}: {
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>;
const trustSignals = [{
  icon: Hospital,
  text: "Hospitals"
}, {
  icon: Activity,
  text: "Surgery Centers"
}, {
  icon: SurgicalMask,
  text: "Surgical Practices"
}, {
  icon: PatientIcon,
  text: "Outpatient Facilities"
}];
export default function PremiumTrustBar() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="175463" id="trustbar" className="bg-background py-12 px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <div ref={ref} className="bg-card rounded-2xl px-6 py-8 transition-all duration-1000 ease-out opacity-100 translate-y-0 !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] md:px-10 md:py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {trustSignals.map((signal, i) => {
            const Icon = signal.icon;
            return <div key={i} data-index={i} className="flex items-center gap-4 group">
                  <div className="flex-shrink-0 bg-accent p-3 rounded-xl transition-colors duration-300 group-hover:bg-accent/20">
                    <Icon className="size-6 text-accent-foreground stroke-[1.5px]" />
                  </div>
                  <p className="text-sm md:text-base font-semibold text-primary tracking-tight leading-snug uppercase">
                    {signal.text}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}